import { c as _c } from "react/compiler-runtime";
import { logout, useJwtToken } from "@website/hooks/auth-manager";
import { MaterialIcon } from "@website/icons/material";
import { Avatar } from "@website/ui/avatar";
import { Sheet } from "@website/ui/sheet";
import { Skeleton } from "@website/ui/skeleton";
import { isChannel } from "@website/utils/channel/helpers";
import { numberConvert } from "@website/utils/number-convert";
import profileImage from "../../assets/avatar.svg";
import { ProfileMenuItem } from "./components/profile-menu-item";
import { useGetBalance } from "./services/get-balance-service";
interface Properties {
  isOpen: boolean;
  close: () => void;
}
export function ProfileMenu(t0) {
  const $ = _c(35);
  const {
    isOpen,
    close
  } = t0;
  const {
    name: fullName,
    phoneNumber
  } = useJwtToken();
  const {
    balance: t1,
    isLoadingGetBalance
  } = useGetBalance();
  const {
    balance
  } = t1;
  const onClickHandler = _temp;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function onLogout() {
      logout();
      window.location.href = "/";
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const onLogout = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = isChannel(["telesale"]);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isTeleSalesChannel = t3;
  let t4;
  if ($[2] !== balance || $[3] !== isLoadingGetBalance) {
    t4 = isTeleSalesChannel ? [] : [{
      label: "\u06A9\u06CC\u0641 \u067E\u0648\u0644",
      value: isLoadingGetBalance ? <Skeleton width={100} height={20} /> : `${numberConvert(((balance || 0) / 10).toLocaleString(), {
        locale: "fa"
      })} تومان`,
      icon: <MaterialIcon name="account_balance_wallet" variant="outlined" />,
      onClick: () => onClickHandler("/profile/wallet")
    }];
    $[2] = balance;
    $[3] = isLoadingGetBalance;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      label: "\u0633\u0641\u0631\u0647\u0627\u06CC \u0645\u0646",
      icon: <MaterialIcon name="luggage" variant="outlined" />,
      onClick: () => onClickHandler("/profile/my-trips")
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      label: "\u0644\u06CC\u0633\u062A \u0645\u0633\u0627\u0641\u0631\u0627\u0646",
      icon: <MaterialIcon name="people" variant="outlined" />,
      onClick: () => onClickHandler("/profile/passengers-list")
    };
    t7 = isTeleSalesChannel ? [] : [{
      label: "\u0644\u06CC\u0633\u062A \u062A\u0631\u0627\u06A9\u0646\u0634 \u0647\u0627",
      value: "",
      icon: <MaterialIcon name="history" variant="outlined" />,
      onClick: () => onClickHandler("/profile/transactions")
    }];
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      label: "\u062E\u0631\u0648\u062C",
      icon: <MaterialIcon name="logout" />,
      onClick: onLogout
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4) {
    t9 = [...t4, t5, t6, ...t7, t8];
    $[9] = t4;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const profileList = t9;
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Avatar src={profileImage.src} className="size-12 max-h-12 min-w-12" size="large" type="image" variant="circular" />;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = fullName || "\u0646\u0627\u0645 \u06A9\u0627\u0631\u0628\u0631";
  let t12;
  if ($[12] !== t11) {
    t12 = <div className="text-subtitle-2 text-on-surface-high-emphasis">{t11}</div>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== phoneNumber) {
    t13 = numberConvert(phoneNumber?.replaceAll?.("+98", "0"), {
      locale: "fa"
    });
    $[14] = phoneNumber;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t13) {
    t14 = <p className="text-extra-caption text-on-surface-high-emphasis">{t13}</p>;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t12 || $[19] !== t14) {
    t15 = <div>{t12}{t14}</div>;
    $[18] = t12;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== close) {
    t16 = <MaterialIcon name="chevron_left" onClick={close} className="mr-auto" />;
    $[21] = close;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t15 || $[24] !== t16) {
    t17 = <a href="/profile/information" className="flex items-center gap-4 px-6 py-2">{t10}{t15}{t16}</a>;
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== profileList) {
    t18 = profileList.map(_temp2);
    $[26] = profileList;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t17 || $[29] !== t18) {
    t19 = <div className="min-w-[312px] py-3">{t17}{t18}</div>;
    $[28] = t17;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== close || $[32] !== isOpen || $[33] !== t19) {
    t20 = <Sheet onClose={close} open={isOpen} xGap="16px" xPosition="end" yPosition="end">{t19}</Sheet>;
    $[31] = close;
    $[32] = isOpen;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  return t20;
}
function _temp2(item) {
  return <ProfileMenuItem key={item.label} {...item} />;
}
function _temp(pathname) {
  if (typeof window !== "undefined") {
    window.location.href = pathname;
  }
}